import { combineReducers } from "redux";
import receiptSlice from "../views/Authenticated/Receipt/store/reducer";

const reducers = combineReducers({
  receiptSlice,
});

export default reducers;
